// The TanStack form contexts that the form fields read. The app builds its
// form hook (createFormHook) from these same objects, so a field rendered by
// the app and a field rendered in the Catalogue share one context.
import { createFormHookContexts } from '@tanstack/react-form';

export const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();
